import {
    KPI_STATUS_REQUEST,
    KPI_STATUS_ERROR,
    KPI_STATUS_SUCCESS,
} from "../../../constants/closeLoop/kpiDashboard/kpiEvaluationStatusConstant";

const INITIAL_STATE = {
    loading: false,
    error: false,
    errorMessage: '',
    data: "",
};

export const KpiStatusReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case KPI_STATUS_SUCCESS:
            const kpiStatus = action.payload.result;
            const uniquekpiStatus = [...new Set(kpiStatus)];
            let item = undefined;
            uniquekpiStatus.forEach((i) => {
                item = i;
            });

            return {
                ...state,
                loading: false,
                error: false,
                errorMessage: '',
                data: item,
            };

        case KPI_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                errorMessage: action.payload,
                data: undefined,
            };
        case KPI_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: '',
                data: undefined,
            };

        default:
            return state;
    }
};
